import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, Col, Row, Container } from 'react-bootstrap';
import { Link, useParams, Navigate } from 'react-router-dom';
import UserService from '../../../../../services/user';

const User = () => {
    let { id } = useParams()
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [nivel, setNivel] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [redirect, setRedirect] = useState(false);

    async function fetchUsers(id) {
        const response = await UserService.userEdit(id);
        setNome(response.data["nome"]);
        setEmail(response.data["email"]);
        setNivel(response.data["nivel"]);
    }


    useEffect(() => {
        fetchUsers(id);
    }, [id]);

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const func = await UserService.editar(id, {
                nome: nome,
                email: email,
                nivel: nivel
            })
            if (func.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    if (sucesso && !redirect) {
        setTimeout(() => {
            setRedirect(true);
        }, 3000); // 10 segundos
    }

    // Quando redirect virar true → redireciona
    if (redirect) {
        return <Navigate to="/ti/user/listar" />;
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Row xs={1}>
                        <Form onSubmit={HandleSubmit} >
                            <Row xs={1} lg={3}>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="nome">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="nome"
                                            value={nome}
                                            onChange={e => setNome(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group controlId="selectnivel">
                                        <Form.Label>Nível</Form.Label>
                                        <Form.Select required value={nivel} onChange={e => setNivel(e.target.value)}>
                                            <option value={nivel}>{nivel}</option>
                                            <option value="Administrador">Administrador</option>
                                            <option value="Funcionário">Funcionário</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="Email">
                                        <Form.Label>E-mail</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="email"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={3}>
                                    <Button variant="success" type="submit">
                                        Salvar
                                    </Button>
                                </Col>
                            </Row>
                        </Form >
                    </Row>
                    <br />
                    <Link to={'/ti/user/listar'}>
                        <Button variant="danger" type="button">
                            Cancelar
                        </Button>
                    </Link>
                </Container>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Alert variant='success'>
                        Usuário alterado com sucesso!<br />
                        Redirecionando em 3 segundos...
                    </Alert>
                </Container>
            </Fragment>
        )
    }
}

export default User;